import Module from '../../../layout/Module';
import PageUnderConstruction from '../../../PageUnderConstruction/PageUnderConstruction';

const InternalLinks = ({ link }) => {
  return (
    <Module.BodyFullContainer className='flex items-center justify-center'>
      <PageUnderConstruction
        className='flex items-center justify-center bg-muted opacity-25 rounded-lg py-4 px-6'
        description={link}
      />
    </Module.BodyFullContainer>
  );
};

export default InternalLinks;
